import { ApiError } from "@/lib/apiClient";

const BTN_BASE =
  "inline-flex items-center gap-1 rounded-sm border px-3 py-1.5 text-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-500 disabled:cursor-not-allowed disabled:opacity-60";

export const BTN = `${BTN_BASE} border-paper-line-strong bg-paper-3 text-ink-1 hover:bg-paper-tint`;
export const BTN_PRIMARY = `${BTN_BASE} border-teal-600 bg-teal-500 font-medium text-paper-3 hover:bg-teal-600`;
export const BTN_DANGER = `${BTN_BASE} border-status-failed/40 bg-status-failed-bg font-medium text-status-failed hover:bg-paper-tint`;

export function isStatus(error: unknown, ...statuses: number[]): boolean {
  return error instanceof ApiError && statuses.includes(error.status);
}

/** Element id of the Live view panel, for the job screen's waiting banner. */
export const LIVE_VIEW_ID = "live-view";
